import { DefaultApolloClient } from '@vue/apollo-composable';
import VueCompositionAPI, { provide } from '@vue/composition-api';
import { ElementQueries } from 'css-element-queries';
import 'simplebar';
import 'url-polyfill';
import Vue from 'vue';
import VueApollo from 'vue-apollo';
import Vuelidate from 'vuelidate';
import '../node_modules/@fortawesome/fontawesome-pro/css/all.css';
import '../node_modules/prismjs/themes/prism.css';
import '../node_modules/simplebar/dist/simplebar.css';
import '../node_modules/tippy.js/dist/tippy.css';
import '../node_modules/vue-virtual-scroller/dist/vue-virtual-scroller.css';
import '../node_modules/vue2-animate/src/sass/vue2-animate.scss';
import App from './App.vue';
import apolloClient from './api/apollo/apolloClient';
import { installComponents } from './components/ui';
import { FeaturesPlugin } from './config/features';
import Log, { LogLevels } from './helpers/log';
import i18n from './i18n';
import router from './router';
import './scss/default-branding.scss';
import './scss/fonts.scss';
import './scss/print.scss';
import store from './store';
Log.logLevel = LogLevels.DEBUG;
Vue.config.productionTip = false;
// Install component library
installComponents(Vue);
// Add the Vue 3-style composition API
Vue.use(VueCompositionAPI);
// Install custom plugins
Vue.use(FeaturesPlugin);
// Apollo
Vue.use(VueApollo);
const apolloProvider = new VueApollo({ defaultClient: apolloClient });
// Vuelidate
Vue.use(Vuelidate);
// Attach event listener for resizing
ElementQueries.listen();
ElementQueries.init();
new Vue({
    router,
    store,
    i18n,
    apolloProvider,
    setup() {
        provide(DefaultApolloClient, apolloProvider.defaultClient);
    },
    render: (h) => h(App),
}).$mount('#app');
